import { render } from "./ScheduledEmail.vue?vue&type=template&id=964b27c2&scoped=true"
import script from "./ScheduledEmail.vue?vue&type=script&lang=js"
export * from "./ScheduledEmail.vue?vue&type=script&lang=js"

import "./ScheduledEmail.vue?vue&type=style&index=0&id=964b27c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-964b27c2"]])

export default __exports__